define.alias("ember-math-helpers/helpers/atanh", "settings/helpers/atanh");